export default class ApiService {
    constructor() {
        this.api_url = process.env.REACT_APP_BASEURL;
    }

    async refreshToken(keycloak) {
            await keycloak.updateToken(-1).then(() => {
/*                 console.log("Keycloak updated"); */
            })
            .catch(error => {
                console.log("keycloak update error:" + error);
            })
    }
}